import { useQuery } from '@tanstack/react-query'
import { masterApiService } from 'api/config'
import { Area } from 'types/area'

export const AREAS_QUERY_KEY = 'areas'

export const fetchAreas = () =>
  masterApiService.getList<Area>('areas/tree', {
    filteredOut: true,
  })

export const useGetAreas = () => {
  const { data, ...result } = useQuery({
    queryKey: [AREAS_QUERY_KEY],
    queryFn: fetchAreas,
    enabled: true,
  })

  return {
    ...result,
    data: data || [],
  }
}
